export default class AuthToken {
  static get token() {
    return localStorage.getItem("auth")
  }

  static setToken(token) {
    localStorage.setItem("auth", token)
  }
}